import axios from 'axios';
import Storage from "./Storage";
import tools from "./Tools";
import {oAuth} from "../libs/Wechat";
import { router } from '../router';
import { Toast } from 'vant';
import { refreshToken } from '../api/user';
export default {

    domain(){
        return process.env.VUE_APP_WEB_API_URL;
    },

    create(options={}){
        // create http service
        let config = {
            baseURL: this.domain() + "api/recharge", // url前缀
            timeout: 6000 // 请求超时时间
        };

        let arr = Object.getOwnPropertyNames(options);
        if(arr.length > 0 ){
            Object.assign(config,options);
        }

        const httpService = axios.create(config);

        // 拦截器
        httpService.interceptors.request.use(function (config) {
            // 在发送请求之前做些什么
            let users = Storage.get("users");

            if(users != null){
                config.headers['Authorization'] = 'Bearer ' + users
            }
            // config.headers['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3Q6ODA4NSIsImlhdCI6MTY2MjY5NjM0NCwiZXhwIjoxNjYyNjk5OTQ0LCJuYmYiOjE2NjI2OTYzNDQsImp0aSI6ImZyNGEwS2lDdGVqRmF3SXkiLCJzdWIiOjEsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjciLCJyb2xlIjoidXNlciJ9.hULCEUJ30xjxWPW349egJGetLstZS0sXKVuFEYYFUZg'

            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        // 添加响应拦截器
        httpService.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            // console.log(error);
            // switch (error.response.status){
            //     case 401:
            //         oAuth();
            //         // axios.put(config.baseURL+'/authorizations/current').then(response=>{
            //         //     console.log(response)
            //         // })
            //         break;
            //     default:
            //         Toast.fail('网络请求失败请重试');
            // }
            return Promise.reject(error);
        });

        return httpService;
    },

    get(url="",params={}){
        let httpService = this.create();
        return new Promise(function (resolve, reject) {
            httpService.get(url,{
                params: params
            }).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                switch (error.response.status){
                    case 401:
                        oAuth();
                        // axios.put(config.baseURL+'/authorizations/current').then(response=>{
                        //     console.log(response)
                        // })
                        break;
                    default:
                        Toast.fail('网络请求失败请重试');
                }
                reject(error);
            });
        });
    },

    post(url="",params={}){
        let httpService = this.create();
        return new Promise(function (resolve, reject) {
            httpService.post(url,params).then(function (response) {
                if(response.status === 401){
                    Storage.clear();
                    if(tools.isWeiXin()){
                        oAuth();
                    }else{
                        router.push('/public/login');
                    }
                }else{
                    resolve(response.data);
                }
            }).catch(function (error) {
                switch (error.response.status){
                    case 401:
                        oAuth();
                        // axios.put(config.baseURL+'/authorizations/current').then(response=>{
                        //     console.log(response)
                        // })
                        break;
                    default:
                        Toast.fail('网络请求失败请重试');
                }
                reject(error);
            });
        });
    },

    /**
     axios.get(url[, config])
     axios.delete(url[, config])
     axios.head(url[, config])
     axios.post(url[, data[, config]])
     axios.put(url[, data[, config]])
     axios.patch(url[, data[, config]])
     */
    instance(){
        return this.create();
    },

    uploadfiy: function(form,url){
      let http = this.instance();
      return new Promise(function (resolve, reject) {
          http.post(url,form).then(function (response) {
              if(response.status === 401){
                  Storage.clear();
                  if(tools.isWeiXin()){
                      oAuth();
                  }else{
                      router.push('/public/login');
                  }
              }else{
                  resolve(response.data);
              }
          }).catch(function (error) {
              reject(error);
          });
      });
    }
}
